import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/sliderComponent.css"; // Import the CSS file
import company from "../images/BuildForce.jpeg"
import concrete from "../images/Concrete.jpeg"
import furniture from "../images/Furniture.jpeg"
import interior from "../images/UniversalInterios.jpeg"

const SliderComponent = () => {
  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3, // Show 3 slides on medium screens
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, // Show 2 slides on tablets
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1, // Show 1 slide on small screens
        },
      },
    ],
  };

  return (
    <div className="slider-container">
      <h2 className="company-title">Our Company</h2>
      <Slider {...settings}>
        {/* Slide 1 */}
        <div className="card">
          <img
            src={company}
            alt="Build Force Construction"
            className="card-image"
          />
          <div className="card-content">
            <h3>Build Force Construction and service pvt ltd.</h3>
            <p>
              Build force construction and service pvt ltd supply a comprehensive range of concrete products for House Building, Commercial and Industrial construction in both the public and private sectors throughout the Nepal.
            </p>
            <button className="know-more">Know More</button>
          </div>
        </div>

        {/* Slide 2 */}
        <div className="card">
          <img
            src={interior}
            alt="Universal Interior"
            className="card-image"
          />
          <div className="card-content">
            <h3>Universal Interior and Construction Company</h3>
            <p>
              Universal Interior and construction company is a is firm established in 2012 with an aim to provide various construction and interior services. It has evolved to being a diversified construction and interior services with an established and growing national client base engaged infrastructure delivery.
            </p>
            <button className="know-more">Know More</button>
          </div>
        </div>

        {/* Slide 3 */}
        <div className="card">
          <img
            src={concrete}
            alt="Universal Concrete"
            className="card-image"
          />
          <div className="card-content">
            <h3>Universal Concrete Private Limited<br /><br /></h3>
            <p>
              Universal Concrete Pvt ltd supply a comprehensive range of concrete products for House Building, Commercial and Industrial construction in both the public and private sectors throughout the Nepal.
            </p>
            <button className="know-more">Know More</button>
          </div>
        </div>
        {/* Slide 3 */}
        <div className="card">
          <img
            src={furniture}
            alt="Universal Concrete"
            className="card-image"
          />
          <div className="card-content">
            <h3>Sabai Furniture</h3>
            <p>
              Sabai Furniture is a furniture retail company located at Kathmandu.We provide our customers with a massive, yet curated and ever-changing selection of furniture, rugs and home decor at unmatched prices.
            </p>
            <button className="know-more">Know More</button>
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default SliderComponent;
